export default "__VITE_PUBLIC_ASSET__e4cff350__"